/*
This file exists only so that we can load typescript before curalate-all.js,
Most of our typescript runs in main.bundle.js, which runs after curalate-all.js.
As we convert more and more code to typescript, we're going to need certain typescript
files to run before curalate-all.js. That typescript should be imported here.

Eventually, we'll move enough out of curalate-all.js that we can load it after our
typescript and we'll be able to merge this file with the rest of our typescript.
 */

// Global css styles which must be loaded first. The order of the stylesheets below
// must remain unchagned so we can preserve the order in which <style> tags are
// injected into the <head>. The order of the imports below (and the fact that they're
// in early.ts) means that the order in which styles will appear and cascade on the pagee
// will be library-styles => curalate.less => component-styles
/* eslint-disable import/no-unresolved */
import '@css/select2/select2.css';
import 'bootstrap-tour/build/css/bootstrap-tour.css';
import '@css/bootstrap/datepicker.less';
import '@css/pannellum/pannellum.css';
import 'font-awesome/less/font-awesome.less';
import 'trackpad-scroll-emulator/css/trackpad-scroll-emulator.css';
import '@css/curalate.less';
/* eslint-enable import/no-unresolved */

import 'core-js/features/array';
import 'core-js/features/function/name'; // For aws-amplify / graphql, which ends up in our vendor.bundle.
import 'core-js/features/map';
import 'core-js/features/object';
import 'core-js/features/promise';
import 'core-js/features/set';
import 'core-js/features/symbol';
import 'core-js/features/string';

import 'whatwg-fetch';

import { CURALATE } from 'app/curalate.globals';

// Import here because these services need to be initialized on app load with certain config config based on env
// Sometimes need to be turned off based on the environment app is runnning in (prod, local, pdf export)
import 'app/logger/logger-init';
import 'app/initialization/pendo/pendo-init';
import 'app/tracker/mediaTracking/mediaTrackingInit';

// Import this here because it's a required shim for the ng-file-uploader module. We
// must import it after our logging script because logging clobbers the entire
// XMLHttpRequest object, whereas this shim preserves the original while extending
// its functionality. This is disgusting and I'm so so sorry.
//
// In the event this is found to break any logging functionality, we can revert this
// change to fix it, but we'll lose the ability to track the progress of uploads on the
// dashboard. Uploads themselves will be unaffected.
import './node_modules/ng-file-upload/dist/angular-file-upload-html5-shim';

// Bootstrap aws config
import 'app/initialization/amplify/init';

import 'app/initialization/amplify/hub-init';

import 'app/initialization/session/session-loader';

import '@services/tracking-service';
import 'app/curalate.store';
import gaApi from 'app/initialization/ga/ga-api';

import 'app/initialization/facebook/facebook-sdk';

// This is here for the legacy tracking implementation.
// Most users will use the angular service but we still have to expose this for now.
CURALATE.tracking = gaApi;
